<template lang="pug">
    header 404 NOT FOUND
</template>

<script>
export default {
    name: 'PageNotFound'
}
</script>
